import * as React from "react";
import { Grid } from "../grid/grid";
import { Icon } from "../components/icon";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const expandableClass = css({
    backgroundColor: "white",
    display: "block",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingTop: "15px",
    borderRadius: "3px",
    border: `1px solid ${getThemeColorVar("border", "default")}`,
});
const headerClass = css({
    cursor: "pointer",
    borderBottom: `1px solid ${getThemeColorVar("border", "default")}`,
    backgroundColor: getThemeColorVar("white", undefined),
    color: getThemeColorVar("primary", "default"),
    marginLeft: "-15px",
    marginTop: "-15px",
    marginRight: "-15px",
    padding: "10px 15px",
    fontWeight: 600,
});
const contentClass = css({
    marginLeft: "-15px",
    marginRight: "-15px",
    overflow: "hidden",
    transition: "max-height 0.4s",
});
const headlineClass = css({
    fontSize: "16px",
    lineHeight: "25px",
});
const arrowClass = css({
    color: getThemeColorVar("primary", "default"),
    fontSize: "27px",
    lineHeight: "25px",
    transition: "transform 0.4s",
});
const arrowExpandedClass = css({
    transform: "rotateZ(180deg)",
});
export class Expandable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: !!props.initialExpanded,
        };
    }
    render() {
        const { header, children, id, onExpand, onContract } = this.props;
        const { expanded } = this.state;
        const arrowClasses = [arrowClass];
        expanded && arrowClasses.push(arrowExpandedClass);
        const contentStyle = expanded
            ? {}
            : {
                maxHeight: 0,
            };
        const handleClick = () => {
            if (!expanded && onExpand)
                onExpand();
            if (expanded && onContract)
                onContract();
            this.setState({ expanded: !expanded });
        };
        return (React.createElement("div", { className: cx(expandableClass), id: id },
            React.createElement("div", { onClick: () => handleClick(), className: cx(headerClass) },
                React.createElement(Grid, { columnSpec: "1fr fit-content(100%)" },
                    React.createElement("h1", { className: cx(headlineClass) }, header),
                    React.createElement("div", { className: cx(arrowClasses) },
                        React.createElement(Icon, { name: "arrow_drop_up" })))),
            React.createElement("div", { className: cx(contentClass), style: contentStyle }, children)));
    }
}
export default Expandable;
//# sourceMappingURL=expandable.js.map